import { FC } from 'react'
import { UserProtectedRoute } from 'routes'
import { BoardsMessage } from 'components/BoardsPost'

const BoardsMessagesPage: FC = () => {
  return (
    <UserProtectedRoute>
      <BoardsMessage />
    </UserProtectedRoute>
  )
}

export default BoardsMessagesPage
